"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadFeedbackSettings = exports.ILeadFeedbackSettingsRouteEnum = void 0;
const ilead_feedback_google_settings_1 = require("./ilead-feedback-google-settings");
const ilead_feedback_meta_settings_1 = require("./ilead-feedback-meta-settings");
const ilead_feedback_settings_events_1 = require("./ilead-feedback-settings-events");
const ilead_feedback_settings_relay_1 = require("./ilead-feedback-settings-relay");
/**
    * @export
    * @enum {string}
    */
var ILeadFeedbackSettingsRouteEnum;
(function (ILeadFeedbackSettingsRouteEnum) {
    ILeadFeedbackSettingsRouteEnum["Relay"] = "relay";
    ILeadFeedbackSettingsRouteEnum["Direct"] = "direct";
})(ILeadFeedbackSettingsRouteEnum || (exports.ILeadFeedbackSettingsRouteEnum = ILeadFeedbackSettingsRouteEnum = {}));
function parseILeadFeedbackSettings(data) {
    if (data.relay !== null && typeof data.relay === 'object')
        data.relay = (0, ilead_feedback_settings_relay_1.parseILeadFeedbackSettingsRelay)(data.relay);
    if (data.meta !== null && typeof data.meta === 'object')
        data.meta = (0, ilead_feedback_meta_settings_1.parseILeadFeedbackMetaSettings)(data.meta);
    if (data.google !== null && typeof data.google === 'object')
        data.google = (0, ilead_feedback_google_settings_1.parseILeadFeedbackGoogleSettings)(data.google);
    if (data.events !== null && typeof data.events === 'object')
        data.events = (0, ilead_feedback_settings_events_1.parseILeadFeedbackSettingsEvents)(data.events);
    return data;
}
exports.parseILeadFeedbackSettings = parseILeadFeedbackSettings;
